import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import Head from 'next/head';
import { ErrorPage } from './ErrorPage';
import { config, ErrorPageType } from './config';

type ErrorPageContent = {
  description: React.ReactNode;
  headline: React.ReactNode;
  title: React.ReactNode;
};

export type StandaloneErrorPageProps = StandaloneComponentProps<typeof ErrorPage> &
  ({ status: ErrorPageType; errorContent?: never } | { status?: never; errorContent: ErrorPageContent });

export const StandaloneErrorPage: StandaloneComponent<StandaloneErrorPageProps> = ({
  status,
  errorContent,
  ...props
}) => {
  const { title, headline, description } = errorContent ?? config[status!] ?? config[404];

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <ErrorPage {...props}>
        <ErrorPage.Headline>{headline}</ErrorPage.Headline>
        <ErrorPage.Description>{description}</ErrorPage.Description>
      </ErrorPage>
    </>
  );
};
